/**
 * Утилиты для форматирования данных
 */

/**
 * Форматирует дату в локальный формат
 * @param dateString ISO строка даты
 * @returns Форматированная строка даты
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * Форматирует число в денежный формат с валютой
 * @param amount Сумма
 * @param currency Валюта (по умолчанию USD)
 * @returns Форматированная строка суммы с валютой
 */
export const formatCurrency = (amount: number, currency = 'USD'): string => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Форматирует число с разделителями разрядов
 * @param value Число для форматирования
 * @returns Число с разделителями разрядов
 */
export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('ru-RU').format(value);
};

/**
 * Сокращает большие числа (1000 -> 1K, 1000000 -> 1M)
 * @param value Число для сокращения
 * @returns Сокращенное представление числа
 */
export const shortenNumber = (value: number): string => {
  if (value >= 1000000000) {
    return (value / 1000000000).toFixed(1) + 'B';
  }
  if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + 'M';
  }
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'K';
  }
  return value.toString();
}; 